import { useSelector } from 'react-redux';
import { emptyArray } from 'ui-components/default-props/empty';
import Global from '../../../../../../../store/global-selectors';

export const useSelectedProductEntities = (stepPayload) => {
  const productIds = stepPayload?.selectedProducts?.map(({ productId }) => productId) ?? emptyArray;
  return useSelector((state) => Global.selectEntitiesProductsByIds(state, { productIds })?.filter((entity) => !!entity)) || emptyArray;
};
